module.exports = __webpack_public_path__ + "img/card13.bff1759c.jpg";